import corporateInvoiceItem from "./corporateInvoiceItem.component";
import corporateInvoiceItemUrls from "./corporateInvoiceItem.urls";
import CorporateInvoiceItemTransforms from "./corporateInvoiceItem.transforms";

const corporateInvoiceItemModule = angular
  .module("app.components.corporateInvoiceItem", [])
  .component("corporateInvoiceItemPage", corporateInvoiceItem)
  .service("CorporateInvoiceItemTransforms", CorporateInvoiceItemTransforms)
  .config(corporateInvoiceItemUrls);

export default corporateInvoiceItemModule;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoiceItem/corporateInvoiceItem.module.js